import React from "react";
import { motion } from "framer-motion";
import { PROCESS } from "@/lib/lumiqoData";

const HowItWorks = () => {
  return (
    <section
      id="process"
      className="relative py-24 sm:py-32 bg-[#f5f6fa]"
      data-testid="process-section"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#0a1d4d]/10 to-transparent" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-block px-3 py-1 rounded-full bg-[#0a1d4d] text-white text-xs font-semibold tracking-wide uppercase">
              How It Works
            </div>
            <h2
              className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-[#0a1d4d] mt-5 leading-[1.05]"
              data-testid="process-heading"
            >
              A simple
              <span className="lq-text-gradient"> 3-step process</span>.
              <br />
              No back-and-forth.
            </h2>
          </div>
          <p className="text-[#0a1d4d]/65 max-w-md text-base">
            From kickoff call to viral output — clean, fast, and built around
            your brand voice.
          </p>
        </div>

        <div className="relative mt-16">
          {/* connecting line */}
          <div className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px bg-gradient-to-r from-[#1d72ff]/30 via-[#0a1d4d]/30 to-[#1d72ff]/30" />
          <div className="grid md:grid-cols-3 gap-8">
            {PROCESS.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.12 }}
                  className="relative"
                  data-testid={`process-step-${i + 1}`}
                >
                  <div className="relative w-24 h-24 mx-auto md:mx-0">
                    <div className="absolute inset-0 rounded-full bg-white border border-[#0a1d4d]/10 lq-shadow-soft" />
                    <div className="absolute inset-2 rounded-full bg-gradient-to-br from-[#0a1d4d] to-[#1d72ff] flex items-center justify-center text-white">
                      <Icon className="w-7 h-7" strokeWidth={2} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-9 h-9 rounded-full bg-white border border-[#0a1d4d]/10 flex items-center justify-center text-[10px] font-display font-extrabold text-[#1d72ff]">
                      {p.step}
                    </div>
                  </div>
                  <h3 className="font-display font-bold text-2xl text-[#0a1d4d] mt-6 text-center md:text-left">
                    {p.title}
                  </h3>
                  <p className="text-[#0a1d4d]/65 mt-2 text-sm sm:text-base leading-relaxed text-center md:text-left">
                    {p.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
